const variants =
{
    DEFAULT : 'default',
    ERROR   : 'error',
    INFO    : 'info',
    SUCCESS : 'success',
    WARNING : 'warning'
};

export default variants ;